import { useState } from 'react';
import { WellsFargoSettingsApi } from '@/api/clients/wells-fargo-settings/wells-fargo-settings.api';

export const useRegisterWellsFargoWebhookSubscription = () => {
  const [loading, setLoading] = useState(false);

  const registerSubscription = async (organizationId, data) => {
    setLoading(true);
    try {
      return await WellsFargoSettingsApi.registerWebhookSubscription(
        organizationId,
        data,
      );
    } finally {
      setLoading(false);
    }
  };

  return { registerSubscription, loading };
};
